// extracted by mini-css-extract-plugin
export default {"wrap":"ButtonEclipse_wrap__sEUZB","button":"ButtonEclipse_button__9C2Ly"};